import React from "react";

function PlayerDuration({ value }) {
    return <p className="player__duration">{value}</p>;
}

export default PlayerDuration;
